/**
 * The below file is the UrbanFlood Non Inmates Registration service which contains method for doing the API calls.
 * @author: vishal.mishra@velsof.com
 * @date : 01-04-2024
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  UrbanFlood_Create_Non_Inmates_Registration,
  UrbanFlood_Export_Non_Inmates_Registration,
  UrbanFlood_Import_Non_Inmates_Registration,
  Multipart_Form_Data,
  Blob,
  UrbanFlood_Import_Non_Inmates_Registration_Xlsx,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const UrbanFloodNonInmatesRegistrationServices = {};

//#region Method for UrbanFlood Freeze Report listing page.

/**
 * Method for getting the UrbanFlood Freeze Report listing
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
UrbanFloodNonInmatesRegistrationServices.getAll = function (param) {
  return fetch({
    url: UrbanFlood_Create_Non_Inmates_Registration,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    params: param,
  });
};

//#region Method for UrbanFlood Freeze Report .

/**
 * Method for importing the UrbanFlood Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
UrbanFloodNonInmatesRegistrationServices.create = function (data) {
  return fetch({
    url: UrbanFlood_Create_Non_Inmates_Registration,
    method: "post",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for UrbanFlood Freeze Report .

/**
 * Method for importing the UrbanFlood Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
UrbanFloodNonInmatesRegistrationServices.update = function (data, id) {
  return fetch({
    url: UrbanFlood_Create_Non_Inmates_Registration + `/${id}`,
    method: "put",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for UrbanFlood Freeze Report .

/**
 * Method for importing the Non Camp Inmates Registration
 * @param {any} data API data
 * @returns Fetch Method
 */
UrbanFloodNonInmatesRegistrationServices.nonCampInmatesRegistrationImport =
  function (data) {
    return fetch({
      url: UrbanFlood_Import_Non_Inmates_Registration,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: data,
    });
  };

/**
 * Method for importing the Non Camp Inmates Registration Excel
 * @param {any} data API data
 * @returns Fetch Method
 */
UrbanFloodNonInmatesRegistrationServices.nonCampInmatesRegistrationImportExcel =
  function (data) {
    return fetch({
      url: UrbanFlood_Import_Non_Inmates_Registration_Xlsx,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: data,
    });
  };

/**
 * Method for getting the Non Camp Inmates Registration export data
 * @returns Fetch Method
 */
UrbanFloodNonInmatesRegistrationServices.getExportNonInmatesRegistrationData =
  function (payload) {
    return fetch({
      url: UrbanFlood_Export_Non_Inmates_Registration,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: payload,
      responseType: Blob,
    });
  };

export default UrbanFloodNonInmatesRegistrationServices;
